import axios from 'axios';
import VirtualPath from 'meta/utils/virtualPath';
import JsonParams from 'meta/features/json-params';
import moment from 'moment';
import { getRootAppWindow } from 'meta/utils/getRootAppWindow';
axios.defaults.baseURL = `${VirtualPath}/webapi`;
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['X-CSRF-Token'] = JsonParams.CsrfToken || getRootAppWindow(window).JSON_PARAMS.CsrfToken;
axios.defaults.validateStatus = (status) => {
    return status < 400;
};
const dateRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*))?/;
export default (instanceConfig) => {
    if (instanceConfig && instanceConfig.parseDateStrings) {
        instanceConfig.transformResponse = [(data) => {
                /*eslint no-param-reassign:0*/
                if (typeof data === 'string') {
                    try {
                        data = JSON.parse(data, (key, value) => {
                            if (typeof value === 'string') {
                                if (dateRegex.exec(value)) {
                                    return moment(value);
                                }
                            }
                            return value;
                        });
                    }
                    catch (e) { /* Ignore */ }
                }
                return data;
            }];
    }
    return axios.create(instanceConfig);
};
export function errorIsCancel(error) { return axios.isCancel(error); }
export const CancelToken = axios.CancelToken;
